import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey } from '../utils';

/**
 * Seal 渲染器 - 印章识别结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const SealRenderer = ({ params, config, detail, selectRect, onSelect }) => {
  return (
    <>
      {params[config.firstField]?.map((v, index) => {
        const selectRectVal = getSelectRectKey({
          data: v,
          key: config?.RectKey || detail?.rectConfig?.RectKey,
          valStr: v[config.secondField]
        });

        return (
          <Fragment key={`seal-${index}`}>
            <Form.Item
              active
              label={`印章${index + 1}`}
              className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
              onClick={() => {
                onSelect && onSelect(v[config.secondField], selectRectVal);
              }}
            >
              <p className="mb-10">
                <span>印章类型:</span>
                <span>{config.SealShapeList[v.SealShape]}</span>
              </p>
              <p className="mb-10">
                <span>印章主要内容:</span>
                <span>{v[config.secondField]}</span>
              </p>
              {v.OtherTexts?.map((t, tIndex) => (
                <p className="mb-10" key={tIndex}>
                  <span>其他文本内容</span>
                  <span>{t}</span>
                </p>
              ))}
            </Form.Item>
          </Fragment>
        );
      })}
    </>
  );
};

export default SealRenderer;
